import React, {Component} from 'react';

export default class MarketingAlertHeader extends Component {
  render() {
    const {data} = this.props;
    return (
        <div className='header__sticker marketing-alert marketing-alert-header' dangerouslySetInnerHTML={{__html: data}}/>
    )
  }
}